import { render, staticRenderFns } from "./HostingCreate.vue?vue&type=template&id=68ade515&scoped=true"
import script from "./HostingCreate.vue?vue&type=script&lang=js"
export * from "./HostingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ade515",
  null
  
)

export default component.exports